exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qualityInspection-transfer-class-name .ivu-tooltip-inner{max-width:50vw}", ""]);

// exports
